import { render, staticRenderFns } from "./bank-card.vue?vue&type=template&id=f872a8e8&scoped=true&"
import script from "./bank-card.vue?vue&type=script&lang=js&"
export * from "./bank-card.vue?vue&type=script&lang=js&"
import style0 from "./bank-card.vue?vue&type=style&index=0&id=f872a8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872a8e8",
  null
  
)

export default component.exports